module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.1917e3ce.woff2";